if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');

      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if(this.classList.contains('product-form--engraving')) {
        const errorMessage = this.querySelector('.text-limited-required');
        const inputTextLimited = this.querySelector('text-limited input');

        if(inputTextLimited.value.length === 0){
          errorMessage.classList.remove('hidden');
          return;
        }
      }
      
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      // Upsell block
      const upsell = document.getElementById(`Upsell-${this.dataset.sectionId}`);
      if (upsell) {
        const selectedVariantId = upsell.getSelectedVariantId();
        if (selectedVariantId) {
          config.body.set('items[upsell][id]', selectedVariantId);
          config.body.set('items[upsell][quantity]', 1);
        }
      }

      // Apollo Upsell block
      const apollo = document.getElementById(`Apollo-${this.dataset.sectionId}`);
      if (apollo) {
        const selectedVariantId = apollo.getSelectedVariantId();
        if (selectedVariantId) {
          config.body.set('items[apollo][id]', selectedVariantId);
          config.body.set('items[apollo][quantity]', 1);
        }
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async (response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // // Mise a jour dynamique du prix dans l'info livraison du sticky ATC 
          // fetch(window.Shopify.routes.root + 'cart.js')
          //   .then(response => response.json())
          //   .then(data => {
          //     const totalPrice = (data.total_price / 100);
          //     /*if(data.total_price/100 < 200){
          //       document.querySelector(".livraison-estime__calcul").innerHTML = `<strong>Livraison standard <span style="font-weight:bold;">offerte</span></strong>  <span id="livraison-estime-inner"></span>`;
          //       document.querySelector(".livraison-estime__calcul").style.textTransform = "none";
          //       document.getElementById('livraison-estime-inner').innerHTML = "estimée entre le: " + `<strong style="margin-right: 3px;font-weight:bold;"> ${formatDate(date.addDays(3))}</strong> ` + " et le " + `<strong style="margin-left: 3px;font-weight:bold;">${formatDate(date.addDays(7))}</strong>`;
          //     } else {
          //       document.querySelector(".delivery-details").innerHTML = `Livraison standard ` + `<span class="delivery-badge" style="font-weight:bold">ofert</span>  <span id="livraison-estime-inner"></span>`;
          //       document.querySelector(".livraison-estime__calcul").innerHTML = `<strong>Livraison standard <span style="font-weight:bold;">offerte</span></strong>`;
          //     // document.querySelector(".livraison-estime__calcul").style.textTransform = "uppercase";
          //       document.getElementById('livraison-estime-inner').innerHTML = "Livraison estimée le: " + `<strong style="margin-left: 3px;font-weight:bold;"> ${formatDate(date.addDays(1))}</strong> `;
          //     }*/
          //   });

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
            await this.onCartUpdate();
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');

          if(this.closest('modal-js')) this.closest('modal-js').closeModal();
          if(this.classList.contains('product-form--engraving')) {
            this.querySelector('engraving-submit').resetModalEngraving();
          }
        });
    }

    async onCartUpdate() {}

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper =
        this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  }

  customElements.define('product-form', ProductForm);

  class ApolloForm extends ProductForm {
    constructor() {
      super()
    }

    async onCartUpdate() {
      console.log(this.dataset.lineItem)
      const data = {
        id: this.dataset.lineItem,
        properties: {
          _has_apollo_box: true,
        },
      };

      await fetch(routes.cart_change_url, {
        ...fetchConfig(),
        body: JSON.stringify(data),
      })
    }
  }

  customElements.define('apollo-form', ApolloForm);
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const wishlistBlock = document.querySelector('.shopify-app-block:has(wishlist-button-block)');

    const colorwayPicker = document.querySelector('.colorway-picker');

    if(wishlistBlock && colorwayPicker) {
      wishlistBlock.style.display = 'block';
      colorwayPicker.appendChild(wishlistBlock);
    }
  }, 1500);
});